module.exports = __webpack_public_path__ + "static/media/upgrade.343e947f.svg";